import React from 'react';

import TextField from '@material-ui/core/TextField';
import { createStyles, Theme, withStyles } from '@material-ui/core/styles';

import PickupOrder from '../../../models/PickupOrder';

import pickupOrderStyles from '../../pickupOrder/pickupOrder.module.css';
import commonStyles from '../../common/common.module.css';

const TEXT_FIELD_PADDINGS: string = '22px 3px 22px 10px';

const styles = (theme: Theme) =>

  createStyles({
    textField: {
      '& fieldset': {
        borderRadius: '9px'
      }
    },
    input: {
      color: 'var(--primaryblue)',
      fontSize: '14px',
    }
  });

interface CommonOrderAdditionalInformationProps {
  classes: any;
  pickupOrder: PickupOrder;
  handleFieldsInput: Function;
  type: string;
};

const commonOrderAdditionalInformation = (props: CommonOrderAdditionalInformationProps) => {

  const { pickupOrder } = props;
  let label: string = '';
  let fieldName: string = '';
  let value: string = '';

  switch (props.type) {
    case 'trc':
      label = 'Additional info to trucker';
      fieldName = 'truckerInformation';
      value = pickupOrder.trucker_info ? pickupOrder.trucker_info : '';
      break;
    case 'po':
      label = 'General remarks for this Pick Up Order';
      fieldName = 'poAdditionalInformation';
      value = pickupOrder.additional_info;
      break;
    case 'do':
      label = 'General remarks for this Drop Off Order';
      fieldName = 'poAdditionalInformation';
      value = pickupOrder.additional_info;
    break;
    default: break;
  }
  
  return (
    <div className={ `${ pickupOrderStyles.addInfoWrapper  } ${ commonStyles.inputLabelWrapper }` } >
      <label className={ commonStyles.inputLabel }> { label }</label>
			<TextField
				fullWidth={ true }
				id="outlined-disabled"
				placeholder="-- Enter additional information"
				variant="outlined"
				onChange={ (event: any) => props.handleFieldsInput(fieldName, event) }
        value={ value }
        className={ props.classes.textField }
        inputProps={{ style: { padding: TEXT_FIELD_PADDINGS } }}
        InputProps={{ className: props.classes.input }}
			/>
		</div>
  );
}

export default withStyles(styles)(commonOrderAdditionalInformation);